import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "price-input-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_input, {
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _ctx.emitPrice,
      label: _ctx.label,
      type: "number",
      mask: "#.##",
      "fill-mask": "0",
      autocomplete: "off",
      "bg-color": "white",
      "hide-bottom-space": "",
      debounce: "100",
      outlined: "",
      dense: "",
      disable: _ctx.readonly
    }, {
      prepend: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.currency), 1)
      ]),
      _: 1
    }, 8, ["model-value", "onUpdate:modelValue", "label", "disable"])
  ]))
}